import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '/store/RootState';

export const baseSelectors = {
  filters: createSelector(
    (state: RootState) => state.cluster.filters,
    (filters) => filters
  ),
};
